<div class="overlay-close" (click)="close()"></div>
<div class="cover-wrapper" [style.backgroundColor]="messageData?.template_data?.background_color!='' ? messageData?.template_data?.background_color : 'transparent'" [style.backgroundImage]="'url('+backgroundImage+')'">  <div class="icon-wrapper" (click)="backToDetails(!messageData?.isLiked)">
  @if (!messageData?.isLiked) {
    <img
      src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2Fwhiteheart_800x800.png?alt=media"
      alt=""
      class="fav-img"
      />
  }
  @if (messageData?.isLiked) {
    <img
      src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2Fredheart_800x800.png?alt=media"
      alt=""
      class="fav-img"
      />
  }
</div>
<div class="main-title-wrapper">
  <img
    src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2Feuromillions%403x1.svg?alt=media"
    alt=""
    class="euromillions-img"
    />
    <p class="desc-text top-dec" [innerHTML]="messageData?.template_data?.message" [style.color]="messageData?.template_data?.message_color!='' ? messageData?.template_data?.message_color : '#ffffff'"></p>
  </div>
  <ion-button (click)="onCTA()" class="custom-btn" [style.--background]="messageData?.template_data?.button_color!='' ? messageData?.template_data?.button_color : '#ffffff'" [style.color]="messageData?.template_data?.button_label_color!='' ? messageData?.template_data?.button_label_color : '#7564e3'">{{ messageData?.button_label }}</ion-button>
</div>
